import React, { useCallback, useContext, useRef } from 'react';
import { Topic } from 'src/config/topics';
import cn from 'classnames';
import styles from './Drawing.module.scss';
import { TopicContext, TopicContextType } from 'src/app/App';

interface DrawingProps {
  image: string;
  topics: Topic[];
}

export const Drawing: React.VFC<DrawingProps> = ({ image, topics }) => {
  const [selectedTopic, setSelectedTopic] = useContext<TopicContextType>(TopicContext);
  const SVGPathRefs = useRef<Record<string, SVGPathElement>>({});

  const handleSetSelectedTopic = useCallback((topic: Topic) => () => setSelectedTopic(topic), [setSelectedTopic]);

  return (
    <div className={cn(styles['c-drawing'])}>
      <svg
        className={cn(styles['c-drawing__image'])}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 2759 1552"
      >
        <image width="3840" height="2040" xlinkHref={image}  transform="matrix(0.7185 0 0 0.7185 0 86.52)"></image>
        {topics.map((x) => {
          const { key, SVGPath, category } = x;
          const pathLength = SVGPathRefs.current[key]?.getTotalLength();

          return (
            <path
              ref={(r) => {
                if (SVGPathRefs.current[key] || !r) return;
                SVGPathRefs.current[key] = r;
              }}
              key={key}
              d={SVGPath}
              data-id={key}
              onClick={handleSetSelectedTopic(x)}
              style={{ strokeDasharray: pathLength, strokeDashoffset: pathLength }}
              className={cn(styles['c-drawing__path'], {
                [styles['c-drawing__path--primary']]: category === 'tech',
                [styles['c-drawing__path--secondary']]: category === 'health',
                [styles['is-active']]: selectedTopic?.key === x.key,
              })}
            />
          );
        })}
      </svg>
    </div>
  );
};
